import {post} from './http';
/**
 * 获取打赏记录列表
 * @param {*} p
 * @returns
 */
 export const getRewardRecordList = (p) => post('/reward/record', p);


  